import React from 'react';
import { Asset } from '../../../types/asset';
import { RichText } from '../../richText';
import { Document } from '@contentful/rich-text-types';
import classnames from 'classnames';
import { Block } from '../../other/block';

export interface ImageTextAlternativeProps {
  image: Asset;
  title: string;
  content: Document;
  featured?: boolean;
}

export const ImageTextAlternative: React.FC<ImageTextAlternativeProps> = ({ image, title, content, featured }) => {
  if (featured) {
    return (
        <div className={'image-text border-b border-black'}>
          <div className={'max-w-5xl mx-auto'}>
              <div className={'flex flex-col px-6 items-center'}>
                <div className={'h-32 border-l border-gray-500'}/>
                <div className={'flex flex-col sm:flex-row flex-1 border border-black'}>
                  <div className={'w-full sm:w-1/2 p-16'}>
                    <h2 className={'font-playfair text-3xl'}>{title}</h2>
                    <RichText content={content} additionalClass={'mt-4 text-md'} />
                  </div>

                  <div
                      className={'w-full h-96 sm:h-auto sm:w-1/2 bg-cover bg-center border-t sm:border-t-0 sm:border-l border-black'}
                      style={{ backgroundImage: `url(${image.url})` }}
                  />
                </div>
                <div className={'h-32 border-l border-gray-500'}/>
              </div>
          </div>
        </div>
    );
  }

  return (
    <div className={'image-text border-b border-black'}>
      <div className={'max-w-5xl mx-auto px-6 sm:px-0 py-16 sm:py-32'}>
        <div className={'flex flex-col sm:flex-row items-center'}>
          <div className={'mt-12 items-center justify-center flex sm:mt-0 flex-1 order-2 sm:order-1'}>
            <img src={image.url} alt={image.name} className={''} />
          </div>

          <div className={'px-0 sm:px-20 flex-1 order-1 sm:order-2'}>
            <h2 className={'font-playfair text-3xl'}>{title}</h2>
            <RichText content={content} additionalClass={'mt-4 text-md'} />
          </div>
        </div>
      </div>
    </div>
  );
};
